import React from 'react'
import type { PaginationControlsProps } from './pagination.types'
import { PaginationPageButton } from './PaginationPageButton'
import { defaultTranslate } from './pagination.default'

export const PaginationControls: React.FC<PaginationControlsProps> = ({
  currentPage,
  totalPages,
  disabled = false,
  pages,
  onPrevious,
  onNext,
  onPageClick,
  t = defaultTranslate,
}) => {
  return (
    <div className="tw-flex tw-items-center tw-gap-1">
      <button
        className="tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-content-base tw-border-opacity-20 tw-bg-white tw-text-sm tw-font-medium tw-text-content-base tw-transition-all hover:tw-bg-base-300 hover:tw-bg-opacity-50 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-focus-100 focus:tw-ring-offset-1 disabled:tw-cursor-not-allowed disabled:tw-opacity-40"
        onClick={onPrevious}
        disabled={currentPage === 1 || disabled}
        aria-label={t('ui.pagination.previous')}
      >
        &lsaquo;
      </button>

      {pages.map((page, index) => {
        if (page === '...') {
          return (
            <span
              key={`ellipsis-${index}`}
              className="tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-text-content-base tw-opacity-50"
            >
              ···
            </span>
          )
        }

        return (
          <PaginationPageButton
            key={page}
            page={Number(page)}
            isActive={page === currentPage}
            disabled={disabled}
            onClick={onPageClick}
          />
        )
      })}

      <button
        className="tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-content-base tw-border-opacity-20 tw-bg-white tw-text-sm tw-font-medium tw-text-content-base tw-transition-all hover:tw-bg-base-300 hover:tw-bg-opacity-50 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-focus-100 focus:tw-ring-offset-1 disabled:tw-cursor-not-allowed disabled:tw-opacity-40"
        onClick={onNext}
        disabled={currentPage === totalPages || disabled}
        aria-label={t('ui.pagination.next')}
      >
        &rsaquo;
      </button>
    </div>
  )
}
